import React, { useState } from 'react';
import { FiMapPin, FiPhone, FiMail, FiClock, FiX } from 'react-icons/fi';
import { useLanguage } from '../../context/LanguageContext';
import logo from '../../images/MEDC LOGO.jpg';
import '../../styles/components/Footer.css';

const Footer = () => {
  const { t } = useLanguage();
  const [activeModal, setActiveModal] = useState(null);

  const openModal = (modalType) => {
    setActiveModal(modalType);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setActiveModal(null);
    document.body.style.overflow = 'unset';
  };

  const modalContent = {
    privacy: {
      title: 'Privacy Policy',
      content: `
        <h3>Information We Collect</h3>
        <p>We collect information you provide directly to us, such as when you fill out a contact form, apply for membership, or communicate with us.</p>
        
        <h3>How We Use Your Information</h3>
        <p>We use the information we collect to provide, maintain, and improve our services, process your requests, and communicate with you about our cooperative's activities.</p>
        
        <h3>Information Sharing</h3>
        <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as required by law or to provide our services.</p>
        
        <h3>Data Security</h3>
        <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
        
        <h3>Contact Us</h3>
        <p>If you have any questions about this Privacy Policy, please contact us at medcoopmsia@gmail.com or call (082) 287-7886.</p>
      `
    },
    terms: {
      title: 'Terms of Service',
      content: `
        <h3>Acceptance of Terms</h3>
        <p>By accessing and using our website and services, you accept and agree to be bound by these Terms of Service.</p>
        
        <h3>Services</h3>
        <p>MEDCoop provides manpower services including janitorial services, messengers/collectors, company drivers, construction workers, and other allied services.</p>
        
        <h3>User Responsibilities</h3>
        <p>You agree to provide accurate information when using our services and to comply with all applicable laws and regulations.</p>
        
        <h3>Limitation of Liability</h3>
        <p>MEDCoop shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services.</p>
        
        <h3>Modifications</h3>
        <p>We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of modified terms.</p>
        
        <h3>Contact</h3>
        <p>For questions regarding these Terms of Service, contact us at medcoopmsia@gmail.com.</p>
      `
    },
    cookies: {
      title: 'Cookie Policy',
      content: `
        <h3>What Are Cookies</h3>
        <p>Cookies are small text files stored on your device when you visit our website. They help us provide a better user experience.</p>
        
        <h3>How We Use Cookies</h3>
        <p>We use cookies to understand how you interact with our website, remember your preferences, and improve our services.</p>
        
        <h3>Types of Cookies We Use</h3>
        <p><strong>Essential Cookies:</strong> Required for the website to function properly.</p>
        <p><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website.</p>
        <p><strong>Preference Cookies:</strong> Remember your settings and preferences.</p>
        
        <h3>Managing Cookies</h3>
        <p>You can control and manage cookies through your browser settings. Note that disabling cookies may affect your experience on our website.</p>
        
        <h3>Contact Us</h3>
        <p>If you have questions about our Cookie Policy, please contact us at medcoopmsia@gmail.com.</p>
      `
    }
  };
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-main">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={logo} alt="MEDCoop Logo" className="footer-logo-image" />
              <div className="footer-logo-text">
                <span className="logo-name">MEDC</span>
                <span className="logo-tagline">Employees' Development Cooperative</span>
              </div>
            </div>
            <p>
              CDA-registered manpower cooperative since 1997. About 2,500+ personnel 
              across Luzon, Visayas, and Mindanao. Pro-employee policy - giving what is 
              due to our employees.
            </p>
          </div>

          <div className="footer-contact-horizontal">
            <div className="footer-contact-item">
              <div className="icon"><FiMapPin /></div>
              <div className="text">
                <strong>Address</strong>
                Marcela Building, 11 J. Palma Gil Street<br />
                Poblacion District, Davao City<br />
                8000 Davao Region, Philippines
              </div>
            </div>
            <div className="footer-contact-item">
              <div className="icon"><FiPhone /></div>
              <div className="text">
                <strong>Phone</strong>
                (082) 287-7886<br />
                HR: 0998-846-3886 / 0918-912-0332<br />
                Customer Service: 0998-593-0902
              </div>
            </div>
            <div className="footer-contact-item">
              <div className="icon"><FiMail /></div>
              <div className="text">
                <strong>Email</strong>
                medcoopmsia@gmail.com
              </div>
            </div>
            <div className="footer-contact-item">
              <div className="icon"><FiClock /></div>
              <div className="text">
                <strong>Office Hours</strong>
                Mon - Fri: 8:00 AM - 5:00 PM
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Employees' Development Cooperative (MEDC). CDA Reg. No. 6520-11009760 | Est. October 29, 1997</p>
          <div className="footer-bottom-links">
            <button onClick={() => openModal('privacy')} className="footer-policy-link">Privacy Policy</button>
            <button onClick={() => openModal('terms')} className="footer-policy-link">Terms of Service</button>
            <button onClick={() => openModal('cookies')} className="footer-policy-link">Cookie Policy</button>
          </div>
        </div>
      </div>

      {/* Policy Modals */}
      {activeModal && (
        <div className="policy-modal-overlay" onClick={closeModal}>
          <div className="policy-modal" onClick={(e) => e.stopPropagation()}>
            <button className="policy-modal-close" onClick={closeModal}>
              <FiX />
            </button>
            <h2>{modalContent[activeModal].title}</h2>
            <div 
              className="policy-modal-content"
              dangerouslySetInnerHTML={{ __html: modalContent[activeModal].content }}
            />
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;

